/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_UnlinkInputs */

const zh_linked_unlink = /** @type {(inputs: Linked_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解绑`)
};

const en_linked_unlink = /** @type {(inputs: Linked_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink`)
};

const es_linked_unlink = /** @type {(inputs: Linked_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desvincular`)
};

/**
* | output |
* | --- |
* | "Unlink" |
*
* @param {Linked_UnlinkInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const linked_unlink = /** @type {((inputs?: Linked_UnlinkInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_UnlinkInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linked_unlink(inputs)
	if (locale === "en") return en_linked_unlink(inputs)
	return es_linked_unlink(inputs)
});